export default __webpack_public_path__ + "static/media/myInfo_business_neutral.776ab90a.svg";